module.exports = __webpack_public_path__ + "img/ic-collapse.cd9ffd34.svg";